<router-outlet></router-outlet>

<!--<div class="flex flex&#45;&#45;row flex&#45;&#45;nowrap flex&#45;&#45;center flex&#45;&#45;middle" style="height: 100vh">
  <wfm-spinner [show]="true" [size]="55"></wfm-spinner>
</div>-->

<div id="angular-js-popovers" class="angular-js-app angular-js-popovers"></div>
